<app-modal-wrap
	(onClose)="onClose.emit()"
	modalWrapperClass="modal-750"
>
	<h3 header>{{ doctype | langVal }}</h3>
	@if (
		permsService.perms?.administrative || permsService.perms?.clinic_financial
	) {
		@if (doctype !== "admininvoice") {
			<div class="row">
				<div class="col-12">
					<app-gen-button-group
						[actualObj]="this"
						fieldName="doctype"
						[options]="finresourceDocType_display"
						title_ph_lang="fin_doctype"
						(changeEvent)="changeDoctype(doctype)"
						isTab
					/>
				</div>
			</div>
			@if (!finresourceObj.contact_id) {
				<div class="header-totals-row d-flex justify-content-between">
					<div>
						{{
							("total_lm_prices" | langVal) + " " + (lastMonth | langVal) + ": "
						}}
						<span>{{ finresourceObj.total_lm_prices | finNumber }}</span>
					</div>
					<div>
						{{
							("total_until_lm_debt" | langVal) +
								" " +
								(lastMonth | langVal) +
								": "
						}}
						<span>{{
							finresourceObj.total_until_lm_debt < 0
								? 0
								: (finresourceObj.total_until_lm_debt | finNumber)
						}}</span>
					</div>
					<div>
						{{ ("total_total_debt" | langVal) + ": " }}
						<span>{{ finresourceObj.total_total_debt | finNumber }}</span>
					</div>
				</div>
			}
		}
		@if (doctype === "external_invoice") {
			<app-external-invoice
				[resource]="resource"
				[resourceId]="resourceId"
				[is_add_assoc]="is_add_assoc"
				(onClose)="onClose.emit(null)"
			/>
		} @else {
			<div class="d-flex flex-wrap">
				<div class="form-group colstat colstat-small-triple">
					@if (doctype | inArray: ["admininvoice", "proforma", "justinvoice"]) {
						<label>{{ "to" | langVal }}</label>
					}
					@if (doctype | inArray: ["invoice", "receipt", "selfinvoice"]) {
						<label>{{ "paid_by" | langVal }}</label>
					}
					<app-gen-input
						#firstField
						[actualObj]="finresourceObj"
						[errors]="errors"
						title_ph_lang="to"
						[fieldName]="doctype == 'proforma' ? 'for' : 'paid_by'"
						(keyupEvent)="validateEntireForm()"
					>
					</app-gen-input>
				</div>
				@if (finresourceObj.patient_id) {
					<div
						class="form-group d-flex align-items-center"
						style="margin-top: 20px"
					>
						<input
							type="checkbox"
							[disabled]="needsIta"
							[checked]="has_id_number"
							(change)="
								has_id_number = $event.target.checked; validateEntireForm()
							"
						/>

						<div class="mx-2">{{ "add_id_number" | langVal }}</div>
					</div>
					@if (has_id_number) {
						<div
							class="form-group colstat-small"
							style="margin-top: 20px"
						>
							<app-gen-input
								[actualObj]="finresourceObj"
								fieldName="id_number"
								[errors]="errors"
								(keyupEvent)="validateEntireForm()"
							/>
						</div>
					}
				}
				@if (finresourceObj.payor_id || finresourceObj.contact_id) {
					<div class="form-group colstat-small">
						<label>{{ "hp" | langVal }}</label>
						<app-gen-input
							[actualObj]="finresourceObj"
							fieldName="bn_number"
							[errors]="errors"
							(keyupEvent)="validateEntireForm()"
						/>
					</div>
				}
			</div>
			<div class="d-flex gap-3">
				@if (
					doctype
						| inArray
							: [
									"invoice",
									"receipt",
									"selfinvoice",
									"admininvoice",
									"proforma",
									"justinvoice",
							  ]
				) {
					<div
						class="form-group colstat colstat-small-triple"
						style="margin-inline-end: 51px"
					>
						<label class="inline">{{ "for" | langVal }}</label>
						<app-gen-input
							[actualObj]="finresourceObj"
							[errors]="errors"
							fieldName="description"
							title_ph_lang="for"
							(keyupEvent)="validateEntireForm()"
						/>
					</div>
				}

				@if (
					doctype == "invoice" ||
					doctype == "justinvoice" ||
					(doctype == "receipt" && isNgo)
				) {
					<div class="form-group colstat colstat-big">
						<label class="inline">{{ "proforma" | langVal }}</label>
						<app-autocomplete-multi
							(chosenEvent)="chooseProformaIds($event)"
							[optionsArray]="proformas"
						/>
					</div>
				}
				@if (doctype == "receipt" && !isNgo) {
					<div class="d-flex gap-3">
						<div class="pad-btns">
							<app-gen-button-group
								[actualObj]="finresourceObj"
								fieldName="without_invoice"
								optionsListName="withoutInvoice_opts"
								tabindex="-1"
								(changeEvent)="validateEntireForm()"
							/>
						</div>
						<div class="form-group colstat-big">
							<label class="inline">{{ "justinvoice" | langVal }}</label>
							<app-autocomplete-multi
								(chosenEvent)="chooseJustinvoiceIds($event)"
								[optionsArray]="justinvoices"
							/>
						</div>
					</div>
				}
				@if (doctype == "justinvoice") {
					<div class="form-group colstat-big">
						<label class="inline">{{ "receipt" | langVal }}</label>
						<app-autocomplete-multi
							(chosenEvent)="chooseReceiptIds($event)"
							[optionsArray]="receipts"
						/>
					</div>
				}
			</div>
			@if (doctype | inArray: ["proforma"]) {
				<div
					class="colstat-small-triple pt-3"
					style="margin-inline-end: 51px"
				>
					<app-gen-input
						[actualObj]="finresourceObj"
						[errors]="errors"
						fieldName="attached_summary_text"
						title_ph_lang="attached_summary"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}

			@if (
				!invoice_per_followup &&
				doctype !== "admininvoice" &&
				(doctype !== "receipt" || isNgo) &&
				resource != "contact" &&
				resource != "user" &&
				show_payment_details == "yes"
			) {
				<div class="form-group row">
					<div class="col-5 col-lg-3">
						<label class="inline">{{ "from_date" | langVal }}</label>
						<app-date-picker
							#fromDate
							[actualObj]="finresourceObj"
							[errors]="errors"
							(changeEvent)="currentPeriod = 'date_range'; onDateChange()"
							fieldName="from_date"
							[addonObject]="{ after: { icon: 'calendar' } }"
						/>
					</div>
					<div class="col-5 col-lg-3">
						<label class="inline">{{ "to_date" | langVal }}</label>
						<app-date-picker
							#toDate
							[actualObj]="finresourceObj"
							[errors]="errors"
							fieldName="to_date"
							(changeEvent)="currentPeriod = 'date_range'; onDateChange()"
							[addonObject]="{ after: { icon: 'calendar' } }"
						/>
					</div>
					<div class="col-12 col-lg-6">
						<label class="inline">{{ "period" | langVal }}</label>
						<div style="display: block">
							<app-gen-button-group
								[actualObj]="this"
								fieldName="currentPeriod"
								[options]="periodInputs"
								title_ph_lang="period"
								(changeEvent)="chPeriod()"
							/>
						</div>
					</div>
				</div>
				<div>
					<app-wysiwyg
						#payment_detailsWysiwyg
						[actualObj]="finresourceObj"
						[errors]="errors"
						fieldName="payment_details"
						[maxHeight]="200"
					/>
				</div>
			}

			@if (invoice_per_followup) {
				<div>
					@if (followupsLoading) {
						<div class="followups-loader">
							<app-spin />
							<span>{{ "loading" | langVal }}</span>
						</div>
					} @else {
						<div class="table-responsive my-4 mx-3">
							<table
								style="width: 100%"
								class="invoice-payment-details table table-hover table-striped"
							>
								<thead>
									<tr>
										<th>
											<input
												type="checkbox"
												[checked]="followupsAllChecked"
												(change)="checkAll($event.target.checked)"
											/>
										</th>
										@if (resource == "payor") {
											<th>{{ "patient" | langVal }}</th>
										}
										<th>{{ "type" | langVal }}</th>
										<th>{{ "date" | langVal }}</th>
										@if (show_prices_withoutvat_in_finresource) {
											<th>{{ "price_without_vat" | langVal }}</th>
										}
										<th>{{ "price" | langVal }}</th>
										@if (is_add_assoc) {
											<th>{{ "therapist" | langVal }}</th>
										}
									</tr>
								</thead>
								<tbody>
									@for (followup of followups; track followup) {
										<tr>
											<td>
												<input
													type="checkbox"
													[checked]="followup.checked"
													(change)="
														followupCheck(followup, $event.target.checked)
													"
												/>
											</td>
											@if (resource == "payor") {
												<td>{{ followup.patient_name }}</td>
											}
											<td>{{ followup.meetingtype_name }}</td>
											<td>{{ followup.date | dateFormat }}</td>
											@if (show_prices_withoutvat_in_finresource) {
												<td class="display-number">
													{{ followup.price_without_vat | finNumber }}
												</td>
											}
											<td class="display-number">
												{{ followup.price | finNumber }}
											</td>
											@if (is_add_assoc) {
												<td>{{ followup?.assoc }}</td>
											}
										</tr>
									}

									@if (credit != 0) {
										<tr>
											<td>
												<input
													type="checkbox"
													[checked]="isCreditChecked"
													(change)="creditCheck($event.target.checked)"
												/>
											</td>
											<td [attr.colspan]="resource == 'payor' ? 3 : 2">
												{{
													(credit > 0 ? "there_is_credit" : "there_is_debt")
														| langVal
												}}
											</td>
											@if (show_prices_withoutvat_in_finresource) {
												<td></td>
											}
											<td class="display-number">
												{{ -credit | finNumber }}
											</td>
										</tr>
									}
									@if (followups.length || credit != 0) {
										<tr>
											<td></td>
											<td [attr.colspan]="resource == 'payor' ? 3 : 2">
												{{ "total" | langVal }}
											</td>
											@if (show_prices_withoutvat_in_finresource) {
												<td></td>
											}
											<td class="display-number">
												{{ followupsAndCreditSum | finNumber }}
											</td>
										</tr>
									}
								</tbody>
							</table>
						</div>
					}
					<div
						style="margin: 10px"
						class="d-flex justify-content-end gap-3"
					>
						<div>
							<app-gen-button-group
								class="btn-bottom"
								[actualObj]="this"
								fieldName="showPaymentDetailsButton"
								optionsListName="showPaymentDetails_opts"
								tabindex="-1"
							/>
						</div>
						@if (isFinanciallyNew) {
							<div>
								<button
									class="btn btn-primary"
									(click)="modalProps = { name: 'prompt-input-field' }"
								>
									{{ "add_former_debt" | langVal }}
								</button>
							</div>
						}
					</div>
				</div>
			}
			@if (payment_for_future_meetings) {
				<div>
					@if (!payment_for_future_meetings_clicked) {
						<div class="followups-loader">
							<button
								class="btn btn-primary"
								(click)="getFutureFuses()"
							>
								{{ "insert_future_meetings" | langVal }}
							</button>
						</div>
					} @else {
						<app-spin-or-content [isSpin]="isGettingFutureFuses">
							<div class="table-responsive my-4 mx-3">
								<table
									style="width: 100%"
									class="invoice-payment-details table table-hover table-striped"
								>
									<thead>
										<tr>
											<th>
												<input
													type="checkbox"
													[checked]="futureFusesAllChecked"
													(change)="checkAllFutureFuses($event.target.checked)"
												/>
											</th>
											@if (resource == "payor") {
												<th>{{ "patient" | langVal }}</th>
											}
											<th>{{ "type" | langVal }}</th>
											<th>{{ "date" | langVal }}</th>
											@if (show_prices_withoutvat_in_finresource) {
												<th>{{ "price_without_vat" | langVal }}</th>
											}
											<th>{{ "price" | langVal }}</th>

											@if (is_add_assoc) {
												<th>{{ "therapist" | langVal }}</th>
											}
										</tr>
									</thead>
									<tbody>
										@for (fus of futureFuses; track fus) {
											<tr>
												<td>
													<input
														type="checkbox"
														[checked]="fus.checked"
														(change)="
															futureFusCheck(fus, $event.target.checked)
														"
													/>
												</td>
												@if (resource == "payor") {
													<td>{{ fus.patient_name }}</td>
												}
												<td>{{ fus.meetingtype_name }}</td>
												<td>{{ fus.date | dateFormat }}</td>
												@if (show_prices_withoutvat_in_finresource) {
													<td class="display-number">
														{{ fus.price_without_vat | finNumber }}
													</td>
												}
												<td class="display-number">
													{{ fus.price | finNumber }}
												</td>
												@if (is_add_assoc) {
													<td>{{ fus?.assoc }}</td>
												}
											</tr>
										}

										@if (futureFuses.length) {
											<tr>
												<td></td>
												@if (show_prices_withoutvat_in_finresource) {
													<td></td>
												}
												<td [attr.colspan]="resource == 'payor' ? 3 : 2">
													{{ "total" | langVal }}
												</td>
												<td class="display-number">
													{{ futureFusesSum | finNumber }}
												</td>
											</tr>
										}
									</tbody>
								</table>
							</div>
						</app-spin-or-content>
					}
				</div>
			}

			<div class="row">
				@if (doctype | inArray: ["proforma", "justinvoice"]) {
					<div class="colstat-price">
						<label>{{ "totall" | langVal }}</label>
						<app-gen-input
							#proformaTotal
							className="input-number"
							[actualObj]="finresourceObj"
							[errors]="errors"
							title_ph_lang="totall"
							fieldName="total"
							(keyupEvent)="
								numOnly(finresourceObj, 'total');
								updateVat();
								validateEntireForm()
							"
						/>
					</div>
					@if (hasCurrentPlus) {
						<div class="form-group colstat colstat-price">
							<label class="inline">{{ "current_plus" | langVal }}</label>
							<app-gen-input
								[actualObj]="finresourceObj"
								[errors]="errors"
								isNumber
								fieldName="current_plus"
								title_ph_lang="current_plus"
								(keyupEvent)="validateEntireForm()"
							/>
						</div>
					}
				}

				@if (
					doctype
						| inArray: ["invoice", "admininvoice", "receipt", "selfinvoice"]
				) {
					<div class="col-12">
						@for (line of finresourceObj.invoicelines; track line) {
							<div class="invoice-line-tr">
								<div class="d-flex gap-3">
									<div class="colstat-price">
										<label class="inline">{{ "sum" | langVal }}</label>
										<div>
											<app-gen-input
												tabindex="-1"
												[className]="'input-number sum_' + line.hash"
												[actualObj]="line"
												[errors]="line.errors"
												fieldName="sum"
												(keyupEvent)="numOnly(line, 'sum')"
												(changeEvent)="numOnly(line, 'sum', true)"
											/>
										</div>
									</div>

									<div>
										<div class="form-group">
											<label>{{ "payment_type" | langVal }}</label>
											<app-gen-button-group
												[actualObj]="line"
												fieldName="paymentmethod"
												optionsListName="paymenttype_opts"
												title_ph_lang="payment_type"
												(changeEvent)="onChangePaymentmethod(line)"
											>
											</app-gen-button-group>
										</div>
									</div>
									<div class="form-group colstat-price">
										<label>{{ "repayment_date" | langVal }}</label>
										<app-date-picker
											[actualObj]="line"
											[errors]="line.errors"
											fieldName="repayment_date"
											(changeEvent)="validateEntireForm()"
											[addonObject]="{ after: { icon: 'calendar' } }"
										/>
									</div>
									<div class="text-end">
										<button
											(click)="deleteLine(line)"
											class="btn btn-icon"
											titleLang="remove_invoiceline"
											icon="delete"
										></button>
									</div>
								</div>
								@if (
									line.paymentmethod | inArray: ["cheque", "bank_transfer"]
								) {
									<div class="d-flex gap-3">
										<div class="form-group">
											<label>{{ "account" | langVal }}</label>
											<div>
												<app-gen-select
													[actualObj]="line"
													[errors]="line.errors"
													fieldName="account_num"
													optionFieldId="number"
													title_ph_lang="bankaccount"
													(changeEvent)="validateEntireForm()"
													[options]="bankaccounts"
													[hasNone]="line.paymentmethod == 'bank_transfer'"
													hasPlus
													plusLang="add"
													(plusClick)="openAddBankaccountModal(line)"
												/>
											</div>
										</div>

										@switch (line.paymentmethod) {
											@case ("cheque") {
												<div class="form-group colstat-small">
													<label>{{ "cheque_num" | langVal }}</label>
													<app-gen-input
														[className]="'cheque_num_' + line.hash"
														[actualObj]="line"
														[errors]="line.errors"
														fieldName="cheque_num"
														(keyupEvent)="validateEntireForm()"
														tabindex="10002"
													/>
												</div>
											}
											@case ("bank_transfer") {
												<div class="form-group colstat-small">
													<label>{{ "ref" | langVal }}</label>
													<app-gen-input
														[className]="'transaction_id_' + line.hash"
														[actualObj]="line"
														[errors]="line.errors"
														tabindex="-1"
														fieldName="transaction_id"
														(keyupEvent)="validateEntireForm()"
														title_ph_lang="ref"
													/>
												</div>
											}
										}
									</div>
								}
								@switch (line.paymentmethod) {
									@case ("credit_card") {
										<div class="d-flex gap-3">
											<div class="form-group colstat-small">
												<div class="input-group">
													<app-gen-input
														[className]="'credit_card_4_digits_' + line.hash"
														[actualObj]="line"
														[errors]="line.errors"
														fieldName="credit_card_4_digits"
														(keyupEvent)="validateEntireForm()"
													/>
												</div>
											</div>
											<div class="form-group colstat-small">
												<app-gen-autocomplete
													[fuzzySearchableClasses]="['creditcards']"
													[actualObj]="line"
													fieldName="credit_card"
													(chosenEvent)="validateEntireForm()"
													[error]="line.errors.credit_card"
													(keyUp)="fuzzyKeyUp($event, line, 'credit_card')"
												/>
											</div>
											<div class="form-group colstat-small">
												<app-gen-autocomplete
													[fuzzySearchableClasses]="['credittypes']"
													[actualObj]="line"
													fieldName="credittype"
													(chosenEvent)="validateEntireForm()"
													[error]="line.errors.credittype"
													(keyUp)="fuzzyKeyUp($event, line, 'credittype')"
												/>
											</div>
											<div class="form-group colstat-small">
												<div class="input-group">
													<app-gen-input
														[className]="'transaction_id_' + line.hash"
														[actualObj]="line"
														[errors]="line.errors"
														tabindex="10003"
														fieldName="transaction_id"
														(keyupEvent)="validateEntireForm()"
													/>
												</div>
											</div>
										</div>
									}
									@case ("paymentapp") {
										<div class="d-flex gap-3">
											<div class="form-group colstat-big">
												<div>
													<app-gen-autocomplete
														title_ph_lang="paymentapp"
														tabindex="10002"
														[fuzzySearchableClasses]="['paymentapps']"
														[className]="'paymentapp_id_' + line.hash"
														[actualObj]="line"
														fieldName="paymentapp_id"
														sortField="id"
														(chosenEvent)="
															validateEntireForm(); chosePaymentApp(line)
														"
														[error]="line.errors.paymentapp_id"
														(keyUp)="fuzzyKeyUp($event, line, 'paymentapp_id')"
													/>
												</div>
											</div>
											<div class="form-group colstat-small">
												<div class="input-group">
													<app-gen-input
														[className]="'transaction_id_' + line.hash"
														[actualObj]="line"
														[errors]="line.errors"
														tabindex="10003"
														fieldName="transaction_id"
														(keyupEvent)="validateEntireForm()"
													/>
												</div>
											</div>
										</div>
									}
								}
							</div>
						}
						@if (errors.noLines) {
							<p class="error">{{ errors.noLines }}</p>
						}
					</div>
				}
			</div>

			@if (
				doctype | inArray: ["invoice", "admininvoice", "receipt", "selfinvoice"]
			) {
				<div class="text-end w-100">
					<button
						class="btn btn-icon btn-plus"
						titleLang="add_one_more_invoiceline"
						(click)="addInvoiceLine()"
						icon="add"
						isImg
					></button>
				</div>
			}
			<div class="row">
				<div class="form-group col-12">
					<label class="control-label">{{ "remarks" | langVal }}</label>
					<app-ta-expands
						tabindex="10004"
						[actualObj]="finresourceObj"
						[errors]="errors"
						fieldName="remarks"
					/>
				</div>
				<div
					class="form-group col-12 col-md-5"
					style="display: inline-block"
				>
					<div>
						@if (no_vat == "no") {
							<app-gen-button-group
								[actualObj]="finresourceObj"
								fieldName="withoutvat"
								optionsListName="withoutvat_opts"
								tabindex="-1"
								(changeEvent)="
									[
										'invoice',
										'admininvoice',
										'receipt',
										'selfinvoice',
									].includes(doctype)
										? sumAndVatInvoice()
										: updateVat()
								"
							/>
						}
					</div>
				</div>
			</div>
			@if (
				(doctype | inArray: ["invoice", "receipt"]) &&
				is_withholding_tax == "yes"
			) {
				<div class="d-flex gap-3 total-invoice-line">
					<div>
						{{ "withholding_tax_percent" | langVal }}:
						<span class="display-number"
							>{{ finresourceObj.withholding_tax_percent }}%</span
						>
					</div>
					<div>
						{{ "withholding_tax" | langVal }}:
						<span class="display-number">{{
							finresourceObj.withholding_tax | finNumber
						}}</span>
					</div>
					<div>
						{{ "total_for_payment" | langVal }}:
						<span class="display-number">{{
							finresourceObj.total_minus_withholding | finNumber
						}}</span>
					</div>
				</div>
			}
			<div class="modal-btns justify-content-between">
				<div class="d-flex gap-3 total-invoice-line">
					<div>
						{{ "total_invoice" | langVal }}:
						<span class="display-number">{{
							finresourceObj.total | finNumber
						}}</span>
					</div>
					<div>
						{{ "vat" | langVal }}:
						<span class="display-number">{{
							finresourceObj.vat | finNumber
						}}</span>
					</div>
				</div>
				<!-- <div class="col-12 modal-btns col-md-5 text-end"> -->
				<div class="mis-auto">
					<app-cancel-btn (click)="onClose.emit()" />
					<app-btn-ext
						[disabled]="!isFormSubmittable"
						(clickEv)="previewObj = { step: 'id' }"
						text="to_preview"
						tabindex="10005"
						[isSpin]="!!previewObj"
					/>
				</div>
			</div>
		}
	}
</app-modal-wrap>

@switch (modalProps?.name) {
	@case ("preview-finresource") {
		<app-preview-finresource
			(onClose)="modalProps = null; handlePreviewClose($event)"
			[headtureRow]="modalProps.headtureRow"
			[finresourceObj]="modalProps.finresourceObj"
			[doctype]="doctype"
		/>
	}
	@case ("prompt-input-field") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="former_debt"
			modalWrapperClass="modal-small-width"
		>
			<app-prompt-input-field
				(onClose)="modalProps = null; $event && createPrevDebtFus($event)"
				bodyTitle="former_debt_text"
				[num]="0"
			/>
		</app-modal-wrap>
	}
	@case ("add-bankaccount") {
		<app-modal-wrap
			(onClose)="modalProps = null; handleAddBankaccountClose()"
			title="bankaccounts"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; handleAddBankaccountClose($event)"
				tableName="bankaccounts"
				[filterField]="resource + '_id'"
				[filterFieldValue]="resourceId"
				[newRowInjectedFields]="[
					{ name: 'name', value: finresourceObj.paid_by },
				]"
			/>
		</app-modal-wrap>
	}
}
@switch (previewObj?.step) {
	@case ("id") {
		<app-get-next-id
			[doctype]="doctype"
			(onDone)="handleId($event)"
		/>
	}
	@case ("headture") {
		<app-get-headture-row (onDone)="handleGetHeadtureRow($event)" />
	}
	@case ("confirm-israel-invoice") {
		<app-modal-wrap
			(onClose)="previewObj = null"
			title="get-israel_invoice"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleIsraelInvoiceConfirm($event)"
				[freeText]="'should_have_israel_invoice' | langVal"
				confirmText="continue"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-total-diff") {
		<app-modal-wrap
			(onClose)="previewObj = null"
			title="to_proceed_with_diff"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleTotalDiffApprove($event)"
				[freeText]="'to_proceed' | langVal"
				confirmText="continue"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-headtures") {
		<app-modal-wrap
			(onClose)="previewObj = null"
			title="headtures"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="handleHeadturesClose($event)"
				tableName="headtures"
				filterField="header_default"
				filterFieldValue="i"
				[filterFieldApiObject]="{ lang: 'iw' }"
				updateRow
			/>
		</app-modal-wrap>
	}
}
